
import Cell from 'vux/src/components/cell/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

export default{
components:{
Cell,
PopupPicker
},
data(){
return {
showConsign:false, //显示弹出的日历
List:[['有托运行李','无托运行李']],
consign:['无托运行李'],
jbStorage: JSON.parse(localStorage.getItem("jbStorage"))||{}
}
},
watch:{
'consign':function(val,oldval){
this.valc()
}
},
methods:{
yz(val){
return this.$until.yzFontColor(val);
},
valc(){
this.consign == '有托运行李'?this.$emit('input','1'):this.$emit('input','0');
this.jbStorage = JSON.parse(localStorage.getItem("jbStorage"));
if(this.jbStorage){
this.jbStorage.luggage = this.consign;
localStorage.setItem('jbStorage',JSON.stringify(this.jbStorage))
}
}
},
mounted(){
if(this.jbStorage){
this.consign =  this.jbStorage.luggage ? this.jbStorage.luggage : ["无托运行李"];
}
this.valc()
}
}



// WEBPACK FOOTER //
// ./src/components/common/ConsignPick.vue